import { render, staticRenderFns } from "./Carrer.vue?vue&type=template&id=2609849c&scoped=true"
import script from "./Carrer.vue?vue&type=script&lang=js"
export * from "./Carrer.vue?vue&type=script&lang=js"
import style0 from "./Carrer.vue?vue&type=style&index=0&id=2609849c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2609849c",
  null
  
)

export default component.exports